/** Calendar month split into five upload slots (days 1–7, 8–14, …). */
export const SALES_WEEKS_PER_MONTH = 5;

export function weekOfMonthFromDate(date = new Date()) {
  const day = date.getDate();
  return Math.min(SALES_WEEKS_PER_MONTH, Math.ceil(day / 7));
}

export function weekDateRangeLabel(year, monthIndex, week) {
  const lastDay = new Date(year, monthIndex + 1, 0).getDate();
  const start = (week - 1) * 7 + 1;
  const end = Math.min(week * 7, lastDay);
  const monthShort = new Date(year, monthIndex, 1).toLocaleString("en-IN", { month: "short" });
  return `${monthShort} ${start}–${end}`;
}

export function salesWeekCategory(week) {
  return `sales_w${week}`;
}

export function salesSparewayWeekCategory(week) {
  return `salesSpareway_w${week}`;
}

export function emptySalesByWeek() {
  return { 1: [], 2: [], 3: [], 4: [], 5: [] };
}

export function flattenSalesByWeek(salesByWeek) {
  const out = [];
  for (let w = 1; w <= SALES_WEEKS_PER_MONTH; w += 1) {
    const rows = salesByWeek?.[w];
    if (Array.isArray(rows) && rows.length) out.push(...rows);
  }
  return out;
}

export function parseWeekFromSalesCategory(category) {
  const m = /^sales_w([1-5])$/.exec(String(category || ""));
  return m ? Number(m[1]) : null;
}

export function parseWeekFromSparewayCategory(category) {
  const m = /^salesSpareway_w([1-5])$/.exec(String(category || ""));
  return m ? Number(m[1]) : null;
}
